import React from "react"
import badge from "badges/apollo.svg"
import { BadgeImage } from "backpack/badges/styled"

const Apollo = props => <BadgeImage src={badge} {...props} />

export default Apollo
